import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';

import {UiLoaderComponent} from './loader.component';

@NgModule({
  declarations: [UiLoaderComponent],
  imports: [
    FormsModule, ReactiveFormsModule, CommonModule
  ],
  exports: [UiLoaderComponent]
})
export class UiLoaderModule { }
